import React from 'react';
import {getIndexProtectorLabel} from "../../shared/common";
import AdditionalCalculatorInfo from '../AdditionalCalculatorInfo/AdditionalCalculatorInfo';
import classes from './Disclaimer.css';
import {connect} from "react-redux";


const disclaimer = (props) => {

    let calculatorInfo = null;

    if (!props.isPrint) {
        calculatorInfo = (
            <div className={classes.additionalInfo}>
                <h2>Additional Calculator Info</h2>
                <AdditionalCalculatorInfo indexProtector={props.indexProtector}/>
            </div>

        );
    }

    const indexProtector = props.indexProtector ? props.indexProtector : 5;
    const isIAAndIAA = indexProtector.indexOf("INDEX ACHIEVER") !== -1 ? true : false;
    let notForWellsFargoContent;
    let andParticipationRatesLabel1;
    let andParticipationRatesLabel2;
    if(props.companyName !== "WELLS_FARGO") {
        andParticipationRatesLabel1 = "caps and participation rates";
        andParticipationRatesLabel2 = "and participation rates";
    }else {
        andParticipationRatesLabel1 = "caps";
    }

    return (
        <div className="disclaimer">
            <h2>Disclaimer</h2>
            <p>
                inStream Solutions, LLC ("inStream") makes no warranties, expressed or implied, as to accuracy, completeness, or results obtained from any information on this presentation. Historical returns are a simplifying assumption used to model investment returns. It uses returns from the past to model returns going forward. However, in the real investment world, returns vary widely and therefore the past returns are not necessarily indicative of future returns. Therefore, one should not think that the historical returns used in this plan will necessarily be accurate going forward.
            </p>
            <p>
                Unlike actual performance, the modeled results may not accurately reflect the effect of certain material economic or market factors. Actual results may be higher or lower due to the impact of these factors. Actual trading practices are not reflected in these results, thus it is unknown what effects these factors may have had on the investment advisor representative’s decision making if it were actually managing client funds during the time period highlighted in this report. No representation is being made that any fund or account will or is likely to achieve profits or losses similar to those shown herein. In fact, there are often sharp differences between hypothetical performance results and the actual results subsequently realized by a client’s portfolio.
            </p>
            <p>
                Any investment involves significant considerations and risks. Each potential investor should obtain and read the applicable prospectus or any other disclosure document from his or her financial professional, and should carefully consider the objectives, risks, and charges and expenses of an investment product before investing. Prospectuses may also be available through the U.S. Securities and Exchange Commission’s Electronic Data Gathering, Analysis, and Retrieval system (EDGAR).
            </p>
            <p>
                IMPORTANT: The projections or other information generated by inStream regarding the likelihood of various investment outcomes are hypothetical in nature, do not reflect actual investment results, and are not guarantees of future results.
            </p>
            <p>
                Separate Account Manager Data © 2014 Morningstar, Inc. All Rights Reserved. The information contained herein: (1) is proprietary to Morningstar and/or its content providers; (2) may not be copied or distributed; and (3) is not warranted to be accurate, complete or timely. Neither Morningstar nor its content providers are responsible for any damages or losses arising from any use of this information. Past performance is no guarantee of future results.
            </p>
            <p>
                Any projection or information generated by inStream regarding the possibility of any financial outcome, is hypothetical, does not reflect actual investment results, and does not guarantee future results.
            </p>
            <p>
                Market conditions for US Equity, Intl Equity, Alternatives, and {getIndexProtectorLabel(props.indexProtector)} were calculated by taking the average annual returns for the corresponding index from 1/1/2016 to 12/31/2025 and taking the 10th, 25th, 75th, and 90th percentile to reflect each condition. For US and Intl Fixed Income, market conditions were calculated using effective duration and bond yields.
            </p>

            <table>
                <thead>
                <tr>
                    <th rowSpan="2" width="20%">Asset Class</th>
                    <th rowSpan="2" width="30%">Index</th>
                    <th colSpan="5" width="50%">Expected Return</th>
                </tr>
                <tr>
                    <th width="10%">Bear</th>
                    <th width="10%">Little Bear</th>
                    <th width="10%">Normal</th>
                    <th width="10%">Little Bull</th>
                    <th width="10%">Bull</th>
                </tr>
                </thead>
                <tbody>
                <tr className="green">
                    <td>US Large Core</td>
                    <td>Morningstar US Large Core</td>
                    <td className="returnvalue">-5.57%</td>
                    <td className="returnvalue">3.77%</td>
                    <td className="returnvalue">11.23%</td>
                    <td className="returnvalue">20.64%</td>
                    <td className="returnvalue">27.22%</td>
                </tr>
                <tr className="green">
                    <td>US Large Value</td>
                    <td>Morningstar US Large Value</td>
                    <td className="returnvalue">-3.97%</td>
                    <td className="returnvalue">0.59%</td>
                    <td className="returnvalue">7.91%</td>
                    <td className="returnvalue">13.70%</td>
                    <td className="returnvalue">21.97%</td>
                </tr>
                <tr className="green">
                    <td>US Large Growth</td>
                    <td>Morningstar US Large Growth</td>
                    <td className="returnvalue">-8.84%</td>
                    <td className="returnvalue">4.49%</td>
                    <td className="returnvalue">19.63%</td>
                    <td className="returnvalue">29.29%</td>
                    <td className="returnvalue">37.87%</td>
                </tr>
                <tr className="green">
                    <td>US Mid Value</td>
                    <td>Morningstar US Mid Value</td>
                    <td className="returnvalue">-8.17%</td>
                    <td className="returnvalue">-1.34%</td>
                    <td className="returnvalue">6.05%</td>
                    <td className="returnvalue">13.74%</td>
                    <td className="returnvalue">26.19%</td>
                </tr>
                <tr className="green">
                    <td>US Mid Growth</td>
                    <td>Morningstar US Mid Growth</td>
                    <td className="returnvalue">-8.79%</td>
                    <td className="returnvalue">3.23%</td>
                    <td className="returnvalue">15.16%</td>
                    <td className="returnvalue">23.78%</td>
                    <td className="returnvalue">35.55%</td>
                </tr>
                <tr className="green">
                    <td>US Small Core</td>
                    <td>Morningstar US Small Core</td>
                    <td className="returnvalue">-11.50%</td>
                    <td className="returnvalue">-2.32%</td>
                    <td className="returnvalue">5.86%</td>
                    <td className="returnvalue">15.79%</td>
                    <td className="returnvalue">29.55%</td>
                </tr>
                <tr className="green">
                    <td>US Small Value</td>
                    <td>Morningstar US Small Value</td>
                    <td className="returnvalue">-13.67%</td>
                    <td className="returnvalue">-4.66%</td>
                    <td className="returnvalue">5.07%</td>
                    <td className="returnvalue">13.16%</td>
                    <td className="returnvalue">29.31%</td>
                </tr>
                <tr className="green">
                    <td>US Small Growth</td>
                    <td>Morningstar US Small Growth</td>
                    <td className="returnvalue">-15.65%</td>
                    <td className="returnvalue">0.09%</td>
                    <td className="returnvalue">11.15%</td>
                    <td className="returnvalue">21.85%</td>
                    <td className="returnvalue">31.08%</td>
                </tr>
                <tr className="green">
                    <td>US REIT</td>
                    <td>Morningstar US REIT</td>
                    <td className="returnvalue">-12.54%</td>
                    <td className="returnvalue">-7.45%</td>
                    <td className="returnvalue">0.67%</td>
                    <td className="returnvalue">10.76%</td>
                    <td className="returnvalue">23.66%</td>
                </tr>
                <tr className="lightgreen">
                    <td>Emerging Markets</td>
                    <td>Morningstar Emerging Markets</td>
                    <td className="returnvalue">-15.42%</td>
                    <td className="returnvalue">-6.16%</td>
                    <td className="returnvalue">6.91%</td>
                    <td className="returnvalue">15.89%</td>
                    <td className="returnvalue">23.58%</td>
                </tr>
                <tr className="lightgreen">
                    <td>Intl Large Blend</td>
                    <td>Morningstar Global Markets</td>
                    <td className="returnvalue">-9.27%</td>
                    <td className="returnvalue">0.30%</td>
                    <td className="returnvalue">10.84%</td>
                    <td className="returnvalue">16.45%</td>
                    <td className="returnvalue">23.88%</td>
                </tr>
                <tr className="lightgreen">
                    <td>Intl Large Value</td>
                    <td>Morningstar Developed Markets</td>
                    <td className="returnvalue">-8.54%</td>
                    <td className="returnvalue">0.93%</td>
                    <td className="returnvalue">11.46%</td>
                    <td className="returnvalue">16.55%</td>
                    <td className="returnvalue">25.04%</td>
                </tr>
                <tr className="lightgreen">
                    <td>Intl Large Growth</td>
                    <td>Morningstar Developed Markets ex-US</td>
                    <td className="returnvalue">-10.40%</td>
                    <td className="returnvalue">-4.32%</td>
                    <td className="returnvalue">6.16%</td>
                    <td className="returnvalue">13.50%</td>
                    <td className="returnvalue">21.89%</td>
                </tr>
                <tr className="lightgreen">
                    <td>Intl Small Blend</td>
                    <td>Morningstar Global Markets ex-US</td>
                    <td className="returnvalue">-12.25%</td>
                    <td className="returnvalue">-4.22%</td>
                    <td className="returnvalue">6.67%</td>
                    <td className="returnvalue">13.89%</td>
                    <td className="returnvalue">22.60%</td>
                </tr>
                <tr className="grey">
                    <td>Commodity</td>
                    <td>Morningstar Global Long-Only Commodity</td>
                    <td className="returnvalue">-10.99%</td>
                    <td className="returnvalue">-5.07%</td>
                    <td className="returnvalue">2.14%</td>
                    <td className="returnvalue">11.81%</td>
                    <td className="returnvalue">21.95%</td>
                </tr>
                <tr className="blue">
                    <td>US Short Corp</td>
                    <td>iShares 1-5 Year Investment Grade Corporate Bond ETF</td>
                    <td className="returnvalue">-3.62%</td>
                    <td className="returnvalue">0.33%</td>
                    <td className="returnvalue">4.27%</td>
                    <td className="returnvalue">8.22%</td>
                    <td className="returnvalue">12.16%</td>
                </tr>
                <tr className="blue">
                    <td>US Short Gov</td>
                    <td>iShares Short Treasury Bond ETF</td>
                    <td className="returnvalue">2.76%</td>
                    <td className="returnvalue">3.21%</td>
                    <td className="returnvalue">3.66%</td>
                    <td className="returnvalue">4.11%</td>
                    <td className="returnvalue">4.56%</td>
                </tr>
                <tr className="blue">
                    <td>US Interm Corp</td>
                    <td>iShares 5-10 Year Investment Grade Corporate Bond ETF</td>
                    <td className="returnvalue">-12.98%</td>
                    <td className="returnvalue">-4.07%</td>
                    <td className="returnvalue">4.85%</td>
                    <td className="returnvalue">13.78%</td>
                    <td className="returnvalue">22.72%</td>
                </tr>
                <tr className="blue">
                    <td>US Interm Gov</td>
                    <td>iShares 3-7 Treasury Bond ETF</td>
                    <td className="returnvalue">-8.94%</td>
                    <td className="returnvalue">-2.56%</td>
                    <td className="returnvalue">3.83%</td>
                    <td className="returnvalue">10.22%</td>
                    <td className="returnvalue">16.62%</td>
                </tr>
                <tr className="blue">
                    <td>TIPS</td>
                    <td>IShares TIPS Bond ETF</td>
                    <td className="returnvalue">-14.87%</td>
                    <td className="returnvalue">-5.47%</td>
                    <td className="returnvalue">3.94%</td>
                    <td className="returnvalue">13.37%</td>
                    <td className="returnvalue">22.81%</td>
                </tr>
                <tr className="lightblue">
                    <td>High Yield</td>
                    <td>iShares Emerging Markets HighYld</td>
                    <td className="returnvalue">-8.01%</td>
                    <td className="returnvalue">-0.54%</td>
                    <td className="returnvalue">6.94%</td>
                    <td className="returnvalue">14.43%</td>
                    <td className="returnvalue">21.93%</td>
                </tr>
                <tr className="lightblue">
                    <td>Global Bonds</td>
                    <td>Vanguard Total International Bond Index Fund</td>
                    <td className="returnvalue">-15.26%</td>
                    <td className="returnvalue">-5.24%</td>
                    <td className="returnvalue">4.80%</td>
                    <td className="returnvalue">14.86%</td>
                    <td className="returnvalue">24.94%</td>
                </tr>
                <tr className="lightestblue">
                    <td>S&P 500</td>
                    <td>^GSPC</td>
                    <td className="returnvalue">-5.52%</td>
                    <td className="returnvalue">5.04%</td>
                    <td className="returnvalue">13.72%</td>
                    <td className="returnvalue">20.00%</td>
                    <td className="returnvalue">28.42%</td>
                </tr>
                <tr className="lightestblue">
                    <td>S&P 500 Risk Control</td>
                    <td>SPXAV10P</td>
                    <td className="returnvalue">-2.79%</td>
                    <td className="returnvalue">2.29%</td>
                    <td className="returnvalue">8.36%</td>
                    <td className="returnvalue">14.95%</td>
                    <td className="returnvalue">18.01%</td>
                </tr>
                <tr className="lightestblue">
                    <td>S&P U.S. Retiree</td>
                    <td>SPRETIRE</td>
                    <td className="returnvalue">-1.55%</td>
                    <td className="returnvalue">0.99%</td>
                    <td className="returnvalue">4.19%</td>
                    <td className="returnvalue">6.74%</td>
                    <td className="returnvalue">7.94%</td>
                </tr>
                <tr className="lightestblue">
                    <td>iShares U.S. Real Estate</td>
                    <td>iShares US Real Estate ETF (IYR)</td>
                    <td className="returnvalue">-13.15%</td>
                    <td className="returnvalue">-5.64%</td>
                    <td className="returnvalue">1.78%</td>
                    <td className="returnvalue">11.08%</td>
                    <td className="returnvalue">25.22%</td>
                </tr>
                <tr className="lightestblue">
                    <td>iShares MSCI EAFE</td>
                    <td>iShares MSCI EAFE ETF (EFA)</td>
                    <td className="returnvalue">-12.18%</td>
                    <td className="returnvalue">-3.82%</td>
                    <td className="returnvalue">5.34%</td>
                    <td className="returnvalue">14.25%</td>
                    <td className="returnvalue">21.87%</td>
                </tr>
                <tr className="lightestblue">
                    <td>SPDR Gold Shares</td>
                    <td>SPDR Gold Shares ETF (GLD)</td>
                    <td className="returnvalue">-4.61%</td>
                    <td className="returnvalue">-0.49%</td>
                    <td className="returnvalue">10.66%</td>
                    <td className="returnvalue">23.70%</td>
                    <td className="returnvalue">37.54%</td>
                </tr>
                {(!isIAAndIAA && props.indexProtector !== "4") && (
                    <tr className="lightestblue">
                        <td>FTBE</td>
                        <td>First Trust Barclays Edge Index</td>
                        <td className="returnvalue">-3.98%</td>
                        <td className="returnvalue">-1.58%</td>
                        <td className="returnvalue">4.29%</td>
                        <td className="returnvalue">7.95%</td>
                        <td className="returnvalue">10.12%</td>
                    </tr>
                )}
                </tbody>
            </table>

            {isIAAndIAA && (
                <p className="smallPrint">
                    <i>This product can only be sold through a Broker/Dealer that is contracted with MassMutual Ascend Life
                    Insurance Company. Any sales solicitation must be accompanied or preceded by a prospectus. To obtain
                        a copy of the prospectus, please visit <a href={"http://MassMutualAscend.com/RILArates"} target={"_blank"}>http://MassMutualAscend.com/RILArates</a>.</i>
                </p>
            )}

            {isIAAndIAA && (
                <p className="smallPrint">
                    <i>This product can only be sold through a Broker/Dealer that is contracted with MassMutual Ascend Life
                    Insurance Company. Any sales solicitation must be accompanied or preceded by a prospectus. To obtain
                        a copy of the prospectus, please visit <a href={"http://MassMutualAscend.com/RILArates"} target={"_blank"}>http://MassMutualAscend.com/RILArates</a>.</i>
                </p>
            )}

            <p className="smallPrint">
                MassMutual Ascend Life Insurance Company is not an investment adviser and the information provided in this document is not investment advice. You
                should consult your investment professional for advice based on your personal circumstances and financial situation. Products and features may vary by state, and may not be available in all states. See specific product disclosure document for details.
            </p>

            <p className="smallPrint">
                The information presented above related to indexed strategies reflect hypothetical {isIAAndIAA ? "caps and upside participation rates" : andParticipationRatesLabel1}, which are not guaranteed rates.
                The actual caps {isIAAndIAA ? "and upside participation rates" : andParticipationRatesLabel2} that
                will apply in the future might be significantly lower. The declared rate strategy offered through the {getIndexProtectorLabel(props.indexProtector)} is not available for
                hypothetical allocations when using this calculator. Any allocations to the declared rate strategy would change the results produced by the calculator. These
                changes could be significant.
            </p>

            <p className="smallPrint">
                Principal Underwriter/Distributor: MM Ascend Life Investor Services, LLC, member FINRA and an affiliate of MassMutual Ascend.
            </p>

            <p className="smallPrint">
                All guarantees based on the claims-paying ability of MassMutual Ascend.
            </p>

            {calculatorInfo}

        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        companyName: state.globalState.companyName
    }
};

export default connect(mapStateToProps)(disclaimer);



// WEBPACK FOOTER //
// ./src/components/Disclaimer/Disclaimer.js